<header id="header" class="header-main">
    <div class="header-content clearfix">
        <nav class="navbar navbar-expand-lg dynamic-header clearfix" role="navigation" #navbar>
            <a class="navbar-brand" (click)="GoToHome()">
                <img src="assets/images/logo-ag-white-logo.svg" alt="Uppie" />
            </a>
            <div class="message-icon-section d-block d-lg-none d-xl-none" *ngIf="showmessage">
                <img src="assets/images/message-icon.svg" alt="message" />
                <span class="message-icon-number message-number">{{this.messageCount}}</span>
            </div>
            <button class="navbar-toggler" type="button" (click)="toggleNavbar()">
                <span class="navbar-toggler-icon">
                    <img src="assets/images/hamburger.svg" alt="Uppie" />
                </span>
            </button>
            <div class="collapse navbar-collapse" [class.show]="navbarOpen" #headerList>
                <ul class="navbar-nav mr-auto menu-item-list">
                    <li class="nav-item menu-item hover-effect" [class.active]="activeHeaderLinks[0]">
                        <a class="nav-link" (click)="GoToHome()" [innerHTML]="'DynamicHeader.Dashboard' | translate | punctuationWrap"></a>
                    </li>

                    <li class="nav-item menu-item contract-menu-item hover-effect" *ngIf="showcontract" [class.active]="activeHeaderLinks[1]">
                        <a class="nav-link" [class.dropdown-toggle]="contractList.length > 1"  [class.link-active]="contractbarOpen" data-toggle="dropdown"
                            (click)="showContractMenu()" [innerHTML]="'DynamicHeader.MyFund' | translate | punctuationWrap"></a>
                        <ul class="dropdown-menu" [class.show]="contractbarOpen" *ngIf="contractList.length > 1">
                            <li class="nav-item menu-item" *ngFor="let contract of contractList">
                                <a class="nav-link" (click)="NavigateToContract(contract)">
                                    <div class="contract-menu-information">
                                        <div class="contract-name">{{contract.ContractName}}</div>
                                        <div class="contract-number">{{contract.ContractNumber}}</div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item menu-item message-menu-item hover-effect" *ngIf="showmessage">
                        <a class="nav-link" (click)="menuNavigation('message')">
                            <div class="message-menu-information">
                                <div class="message-name" [innerHTML]="'DynamicHeader.Message' | translate | punctuationWrap"></div>
                                <div class="message-number">{{this.messageCount}}</div>
                            </div>
                        </a>
                    </li>
                    <li class="nav-item menu-item faq-menu-item hover-effect" *ngIf="false">
                        <a class="nav-link" (click)="menuNavigation('faq')" [innerHTML]="'DynamicHeader.Faq' | translate | punctuationWrap"></a>
                    </li>

                    <li class="nav-item menu-item d-block d-lg-none d-xl-none">
                        <a class="nav-link" (click)="GoToProfile()" [innerHTML]="'DynamicHeader.MyProfile' | translate | punctuationWrap"></a>
                    </li>
                    <li class="nav-item menu-item d-block d-lg-none d-xl-none">
                        <a class="nav-link" href="javascript:void(0)"  (click)="logoutConfirmOpen()" [innerHTML]="'DynamicHeader.Logout' | translate | punctuationWrap"></a>
                    </li>
                </ul>

                <ul class="menu-user-info-list navbar-right d-none d-lg-block d-xl-block">
                    <li class="nav-item menu-item">
                        <div class="user-info-item">
                            <a class="dropdown-toggle nav-link user-info-name" data-toggle="dropdown"
                                (click)="showUserMenu()">
                                {{username}}
                                <app-icon cssClass="user-info-img" [addHoverClass]="false" [icon]="Icon.DefaultAvatar">
                                </app-icon>
                            </a>
                        </div>
                        <ul class="dropdown-menu sub-menu-user" [class.show]="userbarOpen">
                            <li class="nav-item menu-item"><a class="nav-link" (click)="GoToProfile()" [innerHTML]="'DynamicHeader.MyProfile' | translate | punctuationWrap"></a>
                            </li>
                            <li class="nav-item menu-item"><a class="nav-link" href="javascript:void(0)"  (click)="logoutConfirmOpen()" [innerHTML]="'DynamicHeader.Logout' | translate | punctuationWrap"></a></li>
                        </ul>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</header>

<app-logout-confirmation></app-logout-confirmation>


